import { useEffect } from 'react';
import { navigate } from '../lib/navigation';
import AppStatus from './AppStatus';

function RequireAuth({ auth, path, children }) {
  useEffect(() => {
    if (auth.status === 'anonymous') {
      navigate(`/login?next=${encodeURIComponent(path)}`);
    }
  }, [auth.status, path]);

  if (auth.status === 'loading') {
    return <AppStatus title="Loading CreatorCV data" message="Checking your session." />;
  }
  if (auth.status !== 'authenticated') {
    return null;
  }
  return children;
}

export default RequireAuth;
